import { createUseStyles } from 'react-jss';

import { canHover, isLeftToRight } from '../../../styles/helpers';
import { Transition } from '../../../styles/enums';
import { FontWeight } from '../../../styles/fonts';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ colors }: ITheme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',

      padding: [10, 16],
      border: '2px solid',
      borderRadius: 4,

      background: 'var(--x-bg-1)',

      '&.success': {
        borderColor: colors.success,
      },
      '&.warning': {
        borderColor: colors.warning,
      },
      '&.error': {
        borderColor: colors.error,
      },
    },
    typeIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 36,
      height: 36,
      marginInlineEnd: '16px',

      '&.success': {
        borderColor: colors.success,

        '& > svg': {
          '& > path': {
            fill: colors.success,
          },
        },
      },
      '&.warning': {
        borderColor: colors.warning,

        '& > svg': {
          '& > path': {
            fill: colors.warning,
          },
        },
      },
      '&.error': {
        borderColor: colors.error,

        '& > svg': {
          '& > path': {
            fill: colors.error,
          },
        },
      },

      [isLeftToRight()]: {
        marginInlineEnd: 16,
      },
      [isLeftToRight(false)]: {
        marginInlineStart: 16,
      },
    },
    textContent: {
      flex: 1,
    },
    title: {
      display: 'block',
      fontWeight: FontWeight.Bold,
      fontSize: '14px',
      lineHeight: '16px',
      color: colors.white,

      '&.success': {
        color: colors.success,
      },
      '&.warning': {
        color: colors.warning,
      },
      '&.error': {
        color: colors.error,
      },
    },
    description: {
      marginTop: 2,
      fontWeight: FontWeight.Regular,
      fontSize: '12px',
      lineHeight: '14px',
      color: 'var(--x-alert-description-color)',
    },
    closeButton: {
      display: 'inline-block',

      width: 24,
      height: 24,

      border: 'none',
      outline: 'none',

      backgroundColor: 'transparent',
      cursor: 'pointer',

      [canHover()]: {
        '&.error:hover': {
          '& > $closeIcon': {
            '& > svg': {
              '& > path': {
                fill: colors.errorAction,
              },
            },
          },
        },
      },
      [canHover(false)]: {
        '&.error:active': {
          '& > $closeIcon': {
            '& > svg': {
              '& > path': {
                fill: colors.errorAction,
              },
            },
          },
        },
      },
    },
    closeIcon: {
      display: 'block',
      width: '100%',
      height: '100%',

      '& > svg': {
        '& > path': {
          fill: 'var(--x-textf-field-color-1)',
          transition: `fill ${Transition.Fast} ease-in-out`,
        },
      },

      [canHover()]: {
        '&:hover': {
          '&.success': {
            '& > svg': {
              '& > path': {
                fill: colors.success,
              },
            },
          },
          '&.warning': {
            '& > svg': {
              '& > path': {
                fill: colors.warning,
              },
            },
          },
          '&.error': {
            '& > svg': {
              '& > path': {
                fill: colors.error,
              },
            },
          },
        },
      },
    },
  }),
  {
    name: 'alert',
  },
);

export default useStyles;
